import React from "react";
import {
  BlueprintRunnerStepLogEntryType,
  BlueprintRunnerStepLogs,
} from "../../../models/Blueprints";
import { getDifferenceInDatesInMilliseconds } from "../../../utils";
import { Text } from "@merge-api/merge-javascript-shared";

interface LogRowProps {
  log: BlueprintRunnerStepLogs[number];
  startTime: string;
  EventTypeRectangle: React.FC<{ event_type: BlueprintRunnerStepLogEntryType }>;
}

const IntegrationEditorStepLogsTableRow: React.FC<LogRowProps> = ({
  log,
  startTime,
  EventTypeRectangle,
}) => {
  return (
    <div id={log.time} className="flex w-full items-stretch py-0.5">
      <div className="console-table-message flex items-stretch whitespace-nowrap min-w-fit flex-shrink-0 w-auto p-2">
        <div className="flex h-full items-stretch">
          <EventTypeRectangle event_type={log.entry_type} />
        </div>
        <Text variant="sm" className="items-center flex">
          {(getDifferenceInDatesInMilliseconds(startTime, log.time) / 1000).toFixed(2) + "s"}
        </Text>
      </div>
      <div className="text-break align-middle flex-1 min-w-0 flex items-center p-2">
        <Text variant="md">{(log.step_id ? log.step_id + ": " : "") + log.message}</Text>
      </div>
    </div>
  );
};

export default IntegrationEditorStepLogsTableRow;
